module.exports = __webpack_public_path__ + "static/img/TT-2.81f4770d.png";